export default "__VITE_ASSET__C1t372cm__"